<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <Signin></Signin>
    </v-dialog>
  </v-layout>
</template>

<script>
  import { Signin } from './Signin'
  import { mapActions } from 'vuex'
  export default {
    data () {
      return {
        dialog: false
      }
    },
    methods: {
      ...mapActions(['checkSubscription'])
    }
  }
</script>

<style scoped>
  .align-center {
    margin-top: 20%;
    margin-left: calc(50% - 165px);
  }
  .align-center-btn {
    display: block;
    margin-left: calc(50% - 82px);
  }
</style>
<style>
  .align-center-btn * {
    width: 135px;
  }
</style>